import ServiceCRUD from '../../../../services/ServiceGasOrder';

class ReasonService extends ServiceCRUD {
  constructor() {
    super('/api/motivos');
  }
}

export default new ReasonService();
